
import { CustomComponentsProvider } from '@husky-x/gatsby-theme-husky';
import { HistoryList } from '@husky-x/history-list';
import { HistoryMock } from './custom-components-mocks';
import { HistoryMockFr } from './custom-components-mocks-fr';
import React from 'react'

export const wrapRootElement = ({ element }) => (
  <CustomComponentsProvider
    list={[
      {
        key: 'HistoryCustomComponent',
        component: () => <HistoryList {...HistoryMock} />,
      },
      {
        key: 'HistoryCustomComponentFr',
        component: () => <HistoryList {...HistoryMockFr} />,
      },
    ]}
  >
    {element}
  </CustomComponentsProvider>
);
